import axiosAuth from "@/services/axiosAuth";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import { SAFETY_CHECKLIST_API } from "../apiRoutes";

const mutateAddSafetyChecklistItem = async ({
  checklistId,
  data,
}: {
  checklistId: string;
  data: FieldValues;
}) => {
  return await axiosAuth.post(
    `${SAFETY_CHECKLIST_API}/${checklistId}/items`,
    data
  );
};

const useAddSafetyChecklistItemMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      checklistId: string;
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddSafetyChecklistItem,
    ...queryParams,
  });

export default useAddSafetyChecklistItemMutation;
